module.exports = __webpack_public_path__ + "static/assets/352dc6cd98d372680a5297f6ffc50ec4.mp3";